import Controller from "./bulkScriptsUpload.controller";
import template from "./bulkScriptsUpload.html";

const bulkScriptsUpload = {
  template,
  controller: Controller,
};

export default bulkScriptsUpload;



// WEBPACK FOOTER //
// ./src/pages/bulkScriptsUpload/bulkScriptsUpload.component.js